import { HomePage } from './HomePage';

export { HomePage };
